import React from "react";
import "./Blog.css";
import BlogImg1 from "../../../../assets/images/blog-img1.png";
import BlogImg2 from "../../../../assets/images/blog-img2.png";
import BlogImg3 from "../../../../assets/images/blog-img3.png";
import Writing from "../../../../assets/images/services-writing.png";
import Shape1 from "../../../../assets/images/services-shape1.png";
import Dots from "../../../../assets/images/services-dots.png";
import Card3 from "../../../../Components/Cards/Card3";
const Blog = () => {
  return (
    <div className="blog__section">
      <img src={Shape1} alt="" className="blog__section_shape1" />
      <img src={Dots} alt="" className="blog__section_dots" />
      <div className="blog__section_headingwrap">
        <div className="blog__section_headingtitle">READ</div>
        <div className="blog__section_heading">
          <span className="blog__section_headingblack">Our</span>{" "}
          <span className="blog__section_headinggreen">Blog</span>
        </div>
      </div>
      <div className="blog__section_body">
        <div className="blog__section_card">
          <Card3
            image={BlogImg1}
            title="Analytics"
            heading="How great Content helps 
            drive success in Marketplace"
            links={[
              { text: "Individual Taxes", url: "#" },
              { text: "Corporate Taxes", url: "#" },
            ]}
          />
        </div>
        <div className="blog__section_card">
          <Card3
            image={BlogImg2}
            title="Marketing"
            heading="Strossle International AB ranked #1 on Deloitte 2018"
          />
        </div>
        <div className="blog__section_card">
          <Card3
            image={BlogImg3}
            title="Advertising"
            heading="What All Marketers Should Know About Brand Safe"
          />
        </div>
      </div>
    </div>
  );
};

export default Blog;
